import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { rootReducer } from 'reducers'
import { PocketsState } from 'reducers/pocketsReducer'
import { GeneralState } from 'reducers/generalReducer'

export type AppState = {
  pockets: PocketsState
  general: GeneralState
}

const store = createStore(rootReducer, applyMiddleware(thunk))

export { store }
